import React from 'react';
import { GameType } from '../../types/GameType.ts';
import { getMonthGameStatuses } from '../../utils/archiveUtils.ts';
import ArchiveCalendarDay from './ArchiveCalendarDay.tsx';

const DAY_LABELS = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

interface ArchiveCalendarProps {
  gameType: GameType;
  year: number;
  month: number; // 0-indexed
}

export default function ArchiveCalendar(props: ArchiveCalendarProps) {
  const { gameType, year, month } = props;
  const statuses = getMonthGameStatuses(gameType, year, month);
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const firstDayOfWeek = new Date(year, month, 1).getDay(); // 0 = Sunday

  // Check if today is in this month
  const now = new Date();
  const todayDay = now.getFullYear() === year && now.getMonth() === month ? now.getDate() : null;

  // Build weeks
  const weeks: (number | null)[][] = [];
  let currentWeek: (number | null)[] = [];

  // Leading empty cells
  for (let i = 0; i < firstDayOfWeek; i++) {
    currentWeek.push(null);
  }

  for (let day = 1; day <= daysInMonth; day++) {
    currentWeek.push(day);
    if (currentWeek.length === 7) {
      weeks.push(currentWeek);
      currentWeek = [];
    }
  }

  // Trailing empty cells
  if (currentWeek.length > 0) {
    while (currentWeek.length < 7) {
      currentWeek.push(null);
    }
    weeks.push(currentWeek);
  }

  return (
    <div className="archive-calendar">
      <div className="archive-calendar-header">
        {DAY_LABELS.map((label, i) => (
          <div key={i} className="archive-calendar-header-cell">
            {label}
          </div>
        ))}
      </div>
      <div className="archive-calendar-divider" />
      {weeks.map((week, weekIdx) => (
        <div key={weekIdx} className="archive-calendar-week">
          {week.map((day, dayIdx) => {
            if (day == null) {
              return <div key={dayIdx} className="archive-calendar-day archive-calendar-day--empty" />;
            }
            const dayStatus = statuses.get(day);
            return (
              <ArchiveCalendarDay
                key={dayIdx}
                day={day}
                gameNumber={dayStatus?.gameNumber ?? null}
                status={dayStatus?.status ?? null}
                gameType={gameType}
                isToday={day === todayDay}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
}
